<template>
    <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
        <h4><strong style="color:#1A0054">Nuevos administradores</strong></h4>

        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="agregar_admin">
            <h4><strong style="color:#494949">Agregar administrador</strong></h4>
            <small>Completa el formulario para agregar un nuevo usuario administrador, especificar que es un rol especial y sensible</small>
            <br>
            <div class="row justify-content-center align-items-center">
                <div class="col-sm-12 col-md-6 col-lg-6 align-self-center">
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" v-model="newUser.firstname" class="form-control rounded-8 sin-borde"
                                placeholder="Nombre del Usuario" aria-label="Nombre del Usuario" id="admin-name" 
                                />
                            <span class="text-danger" v-if="error.firstname">El nombre del usuario es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="text" v-model="newUser.lastname" class="form-control rounded-8 sin-borde"
                                placeholder="Apellido del usuario" aria-label="Apellido del usuario"
                                id="student-lastname" />
                            <span class="text-danger" v-if="error.lastname">El apellido del usuario es un campo
                                obligatorio</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group">
                            <input type="email" v-model="newUser.email" class="form-control rounded-8 sin-borde"
                                @change="revisarEmailUnico($event)"
                                placeholder="Email de usuario" aria-label="Email de usuario" id="admin-mail" />
                            <small style="color:red" class="d-none" id="validarCorreoTexto">El correo tiene un formato no
                                valido.</small>
                            <span class="text-danger" v-for="(error, i) of error.email" :key="i">{{ error }} <br /></span>
                        </div>
                    </div>
                    <div v-if="empresas.length > 0 && issuperadmin == 'true'" class="row mt-3">
                        <div class="form-group gap-2">
                            <label for="rol">Cliente</label>
                            <select name="empresa" id="empresa" v-model="newUser.client_id" placeholder="Seleccione la empresa"
                                class="form-control rounded-8 sin-borde">
                                <option value="" disabled selected>Seleccione un cliente</option>
                                <option v-for="c of listClients" :key="c.id" :value="c.id" > {{ c.name }} </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-3" v-if="issuperadmin == 'true'">
                        <div class="form-group gap-2">
                            <label for="rol">Tipo de administrador</label>
                            <select name="empresa" id="rol" v-model="newUser.role" placeholder="Seleccione la empresa" class="form-control rounded-8 sin-borde">
                                <option value="" disabled selected>Seleccione un rol de usuario</option>
                                <option v-for="r of getRolesAdmin(roles)" :key="r.id" :value="r.id" > {{ r.name }} </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="d-flex gap-4 justify-content-end">
                            <button id="cancelarAdmin" type="button" @click="cancelar"
                                class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8">
                                Cancelar
                            </button>
                            <button id="agregarAdmin" type="button" @click="agregarUsuario"
                                class="btn btn-primary text-light rounded-8">
                                Guardar administrador
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="carga_masiva_admin">
            <h4><strong style="color:#494949">Carga masiva de usuarios</strong></h4>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <small>Puedes cargar una lista de usuarios desde un archivo de carga masiva... </small>
                    <br>
                    <div class="row">
                        <div v-if="empresas.length > 0" class="col-sm-12 col-md-12 col-lg-8 mt-4">
                            <div class="form-group d-lg-flex align-items-center">
                                <select name="empresa" id="empresa" class="form-control rounded-8 sin-borde"
                                    @change="changeUrl">
                                    <option value="">
                                        Seleccionar empresa para la carga masiva
                                    </option>
                                    <option v-for="(client, index) of empresas" :key="index" :value="client.url">
                                        {{ client.client }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <a href="/templates/template_carga_de_usuarios_masivos.csv" download target="_blank">
                                <u>Descargar plantilla</u>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 align-items-center d-grid justify-content-end">
                    <small class="mb-3">{{ selectedFile ? selectedFile.name : '' }}</small>
                    <v-btn class="bg-utel" rounded dark :loading="isSelecting" @click="handleFileImport">
                        Subir archivo .csv <i></i>
                    </v-btn>
                    <!-- Create a File Input that will be hidden but triggered with JavaScript -->
                    <input ref="uploader" class="d-none" type="file" @change="onFileChanged">
                </div>
            </div>
        </div> 

        <modal-after-create-component :usuario="lastUser" :tipousuario="'admin'"></modal-after-create-component> 
        <modal-info-commom-component v-if="showModalInfo" :info="message" @close="closeModalInfo"></modal-info-commom-component> 
    </div>
</template>

<script>
export default {
    props: ["rol", "clients", "get", "empresas", "clients", "issuperadmin", "urlmassive"],
    data() {
        return {
            roles: this.rol,
            listClients: this.clients,
            url: this.get,   
            lastUser: {
                firstname: "",
                lastname: "",
                role: this.issuperadmin == 'true' ? '' : 'admin',
                client_id:'',
                email:''
            },         
            newUser: {
                firstname: "",
                lastname: "",
                role: this.issuperadmin == 'true' ? '' : 'admin',
                client_id:'',
                email:''
            },
            error: [],
            isSelecting: false,
            selectedFile: null,
            urlMassive: this.empresas.length > 0 ? '' : this.urlmassive,
            message: {
                title: '',
                content: ''
            },
            showModalInfo: false
        };
    },
    methods: {
        agregarUsuario() {
            let context = this;
            let btn = document.getElementById("agregarAdmin");
            let succesCreationBtn = document.getElementById("adminsuccesCreationBtn");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.newUser)
                .then((res) => {
                    this.lastUser = this.newUser;
                    this.newUser = { name: "" };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.textContent = "Guardar administrador";
                        succesCreationBtn.click();
                        context.$emit('reloadtabletab', true);
                        this.$swal('Se ha creado el usuario Administrador.');
                    }, 500);
                })
                .catch((err) => {
                    btn.removeAttribute("disabled");
                    btn.textContent = "Guardar proceso";
                    this.error = err.response.data.errors;
                });
        },
        revisarEmailUnico(event){
            const value = event.target.value;
            let btn = document.getElementById("agregarAdmin");
            axios
                .post(this.urlvalidateemail, { "email": value})
                .then((res) => {
                    const existsEmail = res.data;
                    console.log(existsEmail);
                    if(!existsEmail) {
                        btn.setAttribute("disabled", "disabled");
                        btn.textContent = "El email registrado ya existe";
                        this.$swal("El email registrado ya existe");
                        return;
                    }

                    btn.removeAttribute("disabled", "disabled");
                    btn.textContent = "Guardar Cambios";
                })
                .catch((err) => {
                    // cancel.removeAttribute("disabled");
                    // btn.removeAttribute("disabled");
                    // btn.textContent = "Guardar proceso";
                    // this.error = err.response.data.errors;
                });
        },
        /*getData() {
            let param = "?withUsers=true&admin=true";
            if(this.trashes) param = "?admin=true&onlyTrashes=true";
            
            axios.get(this.url + param ).then((res) => {
                this.desserts = res.data;
            });
        },*/
        changeUrl(e) {
            this.urlMassive = e.target.value;
        },
        handleFileImport() {
            this.isSelecting = true;

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });
            
            // Trigger click on the FileInput
            this.$refs.uploader.click();
        },
        onFileChanged(e) {
            this.selectedFile = e.target.files[0];
            console.log(this.selectedFile);
            this.submitFiles();
        },
        submitFiles() {
            console.log(this.urlMassive);
            if(this.urlMassive == "" || !this.selectedFile){
                this.message.title = "Advertencia!";
                this.message.content = "Debe seleccionar una empresa para subir registros masivos.";
                this.showModalInfo = true;
                return;
            }
            if(!this.selectedFile){
                this.message.title = "Advertencia!";
                this.message.content = "Debe seleccionar un archivo para subir registros masivos.";
                this.showModalInfo = true;
                return;
            }
            if (this.selectedFile) {
                let formData = new FormData();
                formData.append("file", this.selectedFile);
                formData.append("tipo", 'admin');
                axios
                    .post(this.urlMassive, formData)
                    .then(response => {
                        this.message.title = "Proceso exitoso!";
                        this.message.content = "Se ha cargado la información de Usuarios masivos correctamente.";
                        this.$emit('reloadtabletab', true);
                        this.showModalInfo = true;
                    })
                    .catch(error => {
                        this.message.title = "Error!";
                        this.message.content = error;
                        this.showModalInfo = true;
                        console.log({ error });
                    });
            } else {
                //this.message.title = "Error!";
                //this.message.content = "No se ha seleccionado archivo.";
            }
        },
        getRolesAdmin(rol){
            return rol.filter((element)=>{
                return element.name == 'SU' || element.name == 'admin';
            });
        },
        closeModalInfo(){
            this.showModalInfo = false;
        },
        cancelar(){
            this.newUser = {
                firstname: "",
                lastname: "",
                role: this.issuperadmin == 'true' ? '' : 'admin',
                client_id:'',
                email:''
            };
        }
    }
}
</script>

<style>

</style>